jQuery(".site-menu-new-items-inner").on("mouseover", function () {
    var currentMenu = jQuery(this).index();
    jQuery(".site-mega-menu-wrap").addClass('mega-menu-open');
    jQuery(".site-mega-menu-wrap").find(".site-mega-menu-inner").hide();
    jQuery(".site-mega-menu-wrap").find(".site-mega-menu-inner").eq(currentMenu).show();
    jQuery('body').find('.active-menu').removeClass('active-menu');
    jQuery('body').find('.site-mega-menu-item:first-child').addClass('active-menu');
});

jQuery(".site-mega-menu-item").on("mouseover", function () {
    jQuery('body').find('.active-menu').removeClass('active-menu');
    jQuery(this).addClass('active-menu');
});

// Close the mega menu when mouse leaves the menu area
jQuery(".site-mega-menu-wrap").on("mouseleave", function () {
    jQuery('body').find('.site-mega-menu-inner').hide();
    jQuery('body').find('.active-menu').removeClass('active-menu');
    jQuery(".site-mega-menu-wrap").removeClass('mega-menu-open');
});

// Keep the mega menu open when hovering over the inner mega menu
jQuery(".site-mega-menu-inner").on("mouseover", function () {
    // Ensure the menu stays open if hovering over the inner content
    jQuery(".site-mega-menu-wrap").addClass('mega-menu-open');
});

// When leaving the mega menu inner area, hide it after a small delay
jQuery(".site-mega-menu-inner").on("mouseleave", function () {
    var $this = jQuery(this);
    setTimeout(function() {
        if (!$this.closest('.site-menu-new-items-inner').is(':hover')) {
            jQuery('body').find('.site-mega-menu-inner').hide();
            jQuery('body').find('.active-menu').removeClass('active-menu');
            jQuery(".site-mega-menu-wrap").removeClass('mega-menu-open');
        }
    }, 100);  // Delay to allow the mouse to move between items without triggering a hide immediately
});


jQuery(document).ready(function(){
  jQuery(".site-dropdown-with-menu>.site-drop-menu-list-item").click(function(){
    jQuery( this ).parent().toggleClass( "site-sub-menu-open" );
  });
  jQuery(".site-drop-menu-sublist-wrap>.site-drop-menu-list-item").click(function(){
    jQuery( this ).parent().toggleClass( "site-sub-inner-open" );
  });
});